import { AddressModel } from './AddressModel';

export class HybrisCustomerDetailsModel {
    public customerId: string | null = null;
    public email: string | null = null;
    public firstName: string | null = null;
    public surname: string | null = null;
    public phone: string | null = null;
    public title: string | null = null;

    public deliveryAddress: AddressModel | null = null;
    public billingAddress: AddressModel | null = null;

    public isCustomerInfoExists: boolean;
}